import FormSection from 'pages/revisions-module/template-editor/editors/form/section/FormSection';
import { useMemo } from 'react';
import Toast from 'components/Toast';
import { useFormSections } from 'pages/revisions-module/template-editor/editors/form/section/FormSectionsDataProvider';

/**
 * A single form section which collects properties of device faults.
 */
export default function DeviceFaults() {
  const { sections } = useFormSections();

  const deviceFaultsSection = useMemo(() => sections.find((section) => section.tab === 'faults'), [sections]);
  const configureInputParams = useMemo(() => ({ hidden: { minWidth: true, maxWidth: true } }), []);

  if (!deviceFaultsSection) {
    return (
      <Toast
        type="fail"
        message="CHYBA: Nenašla sa sekcia pre nedostatky. Kontaktujte administrátora."
        fullWidth
        withCloseButton={false}
      />
    );
  }

  return (
    <FormSection
      data={deviceFaultsSection}
      context="fault"
      disableDelete
      readOnlyName
      helpText="Sekcia sa týka nedostatkov na všetkých zariadeniach"
      configureInputParams={configureInputParams}
      isFirst
      isLast
      disableMoveRowToSection
      disableMoveRowWithinSection
      disableMoveInput
      disableAddNewInput
      disableDeleteRow
    />
  );
}
